/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveResources from './receive-resources';

export default  (resourceId) => (dispatch) => {
    
    dispatch({
        type: actions.RESOURCES_REQUEST,
    });

    if (!resourceId) {
        throw 'no id provided';
    }

    return cecSdk
        .resource(resourceId)
        .get()
        .then((resource) => {
            dispatch({
                type: actions.RESOURCES_REQUEST_SUCCESS,
            });

            dispatch(receiveResources([resource]));
            return resource;
        });
};